export const MAIL_URL = '/mail/v2/mails';
